module.exports = __webpack_public_path__ + "img/home_banner2.3cb7ca04.png";